import React from 'react';
import { Dialog, Stack, Grid, RadioGroup, Radio, Typography, Checkbox } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import flightInfoStyles from './fltloadinfo.module.css';
import { CustomButton, CustomTextField, CustomDialogTitle, CustomDialogAction, CustomInputLabel, StyledCard, CustomDialogContent, CustomRadio, CustomAutocomplete } from '../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';

const FlightLoadInfoModal = (props) => {
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'flt_load_info'} onClose={props.onClose} maxWidth={'md'} fullWidth>
        <CustomDialogTitle id='form-dialog-title'>
          Flight Load Info
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <CustomDialogContent>
          <StyledCard>
            <Stack direction='row'>
              <Grid container spacing={2} columnSpacing={4}>
                <Grid item xs={12}>
                  <RadioGroup
                    aria-labelledby='reportType'
                    name='reportType'
                    onChange={props.handleReportChange}
                    value={props.reportFields.reportType}
                    row
                    defaultValue={'full'}
                    sx={{
                      borderBottom: '1px solid white',
                      paddingBottom: '16px',
                      marginBottom: '8px'
                    }}
                  >
                    <CustomRadio control={<Radio size='small' />} value='full' label='Full Report' className={styles.mr5} />
                    <CustomRadio control={<Radio size='small' />} value='custom' label='Custom Report' />
                  </RadioGroup>
                </Grid>
                {props.reportFields.reportType === 'full' &&
                <Grid item xs={12}>
                  <Typography variant='body2' color='textSecondary' pl={3}>NOTE: A Full Report will include Tonnage Summary, Flight Summary and Flight Details</Typography>
                </Grid>
                }
                {props.reportFields.reportType === 'custom' &&
                <>
                  <Grid item xs={12}>
                    <CustomInputLabel id='tonnage-summary' aria-label='Enter Tonnage Summary'>Tonnage Summary</CustomInputLabel>
                    <CustomAutocomplete
                      multiple
                      id='tonnage-summary'
                      options={props.customReportOptions || []}
                      value={props.tonSumOpts || []}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.title}
                      onChange={(event, value) => props.handleCustomReportSelect('Tonnage Summary', value)}
                      classes={{ option: styles.autocompleteCheckboxOption }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlank fontSize='small' />}
                              checkedIcon={<CheckBox fontSize='small' />}
                              className={styles.autocompleteCheckbox}
                              checked={selected}
                            />
                            {option.title}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <CustomTextField {...params} label='' placeholder={props.tonSumOpts.length > 0 ? '' : 'Tonnage Summary'} />
                      )}
                    />
                  </Grid> 

                  <Grid item xs={12}>
                    <CustomInputLabel id='flight-summary' aria-label='Enter Flight Summary'>Flight Summary</CustomInputLabel>
                    <CustomAutocomplete
                      multiple
                      id='flight-summary'
                      options={props.customReportOptions || []}
                      value={props.flightSumOpts || []}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.title}
                      onChange={(event, value) => props.handleCustomReportSelect('Flight Summary', value)}
                      classes={{ option: styles.autocompleteCheckboxOption }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlank fontSize='small' />}
                              checkedIcon={<CheckBox fontSize='small' />}
                              className={styles.autocompleteCheckbox}
                              checked={selected}
                            />
                            {option.title}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <CustomTextField {...params} label='' placeholder={props.flightSumOpts.length > 0 ? '' : 'Flight Summary'} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomInputLabel id='flight-details' aria-label='Enter Flight Details'>Flight Details</CustomInputLabel>
                    <CustomAutocomplete
                      multiple
                      id='flight-details'
                      options={props.customReportOptions || []}
                      value={props.flightDetOpts || []}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.title}
                      onChange={(event, value) => props.handleCustomReportSelect('Flight Details', value)}
                      classes={{ option: styles.autocompleteCheckboxOption }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlank fontSize='small' />}
                              checkedIcon={<CheckBox fontSize='small' />}
                              className={styles.autocompleteCheckbox}
                              checked={selected}
                            />
                            {option.title}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <CustomTextField {...params} label='' placeholder={props.flightDetOpts.length > 0 ? '' : 'Flight Details'} />
                      )}
                    />
                  </Grid>
                </>
                }
              </Grid>
            </Stack>
          </StyledCard>

        </CustomDialogContent>
        <CustomDialogAction className={`${styles.fSpaceBtw}`}>
          <CustomButton variant='contained' type='reset' className={flightInfoStyles.actionButton} onClick={props.onClose}> Close </CustomButton> 
          <CustomButton variant='contained' type='button' className={flightInfoStyles.actionButton} onClick={props.handleExport}> Download</CustomButton> 
        </CustomDialogAction>
      </Dialog>
    </div>
  );
};
export default FlightLoadInfoModal;